<!--
  Two shells around one body. Standalone is a routed page and keeps the full-width
  container, the `basepage` hook and the back button. Embedded is the community
  feed's right-hand pane, where all of that belongs to the page around it — so it renders
  the post alone, with a close button instead of "back".
-->
@if (!embedded) {
  <div class="fullwidth-layout-container" basepage="secondary">
    <!--
      Back only — no "Post by <author>" title. The post's own header names its author
      immediately below it, so the heading was saying it twice, and on a narrow screen it
      ate the top of the view to do it. The control borrows `.fui-view-toggle` so it
      matches the list/detail toggle and the pane's close button.
    -->
    <div class="community-post-back">
      <div class="fui-view-toggle">
        <button type="button" (click)="back()" aria-label="Back">
          <fa-icon icon="chevron-left" aria-hidden="true"></fa-icon>
          <span class="sr-only">Back</span>
        </button>
      </div>
    </div>
    <div class="container">
      <div class="row learn-content-details">
        <div class="col">
          <ng-container *ngTemplateOutlet="postBody; context: { topMargin: 'm-t-20' }"></ng-container>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="community-post-pane">
    <!--
      No title — the post's own header names its author right below. This row exists to line
      the pane's content up with the feed's: it mirrors the channel-title row opposite it, so
      the post starts level with the "start a new post" input rather than 90px above it.
      The close control borrows `.fui-view-toggle` outright, so it matches the list/detail
      toggle it sits across from.
    -->
    <div class="community-post-pane__header">
      <div class="fui-view-toggle">
        <button type="button" (click)="closed.emit()" aria-label="Close post">
          <fa-icon icon="times" aria-hidden="true"></fa-icon>
          <span class="sr-only">Close post</span>
        </button>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="postBody; context: { topMargin: '' }"></ng-container>
  </div>
}

<ng-template #postBody let-topMargin="topMargin">
  @if (post) {
    <div [class]="topMargin">
      <myp-comment
        [betaStringId]="betaStringId"
        [communityStringId]="communityStringId"
        [comment]="post"
        [isCommunityPost]="true"
        [showCommunityTag]="true"
        [replies]="replies"
        [showAllRepliesByDefault]="showAllReplies"
        [newRepliesState]="newRepliesState"
        (channelSelected)="channelSelected.emit($event)"
      ></myp-comment>
    </div>
  }
  @if (postNotFound) {
    <div class="m-t-50 text-center">
      <div><fa-icon icon="times-circle" class="t-30 c-red"></fa-icon></div>
      <div class="m-t-20 t-16 text-muted">This post is no longer available (or never existed).</div>
    </div>
  }
</ng-template>
